import { useEffect, useState } from "react";

export default function useDarkModeClass(className = "dark-theme") {
    const [isDarkMode, setIsDarkMode] = useState(
        typeof document !== "undefined" &&
        document.body.classList.contains(className),
    );

    useEffect(() => {
        const observer = new MutationObserver(() => {
            setIsDarkMode(document.body.classList.contains(className));
        });
        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ["class"],
        });
        return () => observer.disconnect();
    }, [className]);

    return isDarkMode;
}
